import { notificationApi } from '@/api/notifications.api';

const unwrap = (response) => response.data;

export const notificationService = {
  list: async (params) => {
    const res = await notificationApi.list(params);
    return { notifications: unwrap(res).data.notifications, meta: unwrap(res).meta };
  },
  getUnreadCount: async () => {
    const res = await notificationApi.getUnreadCount();
    return unwrap(res).data.count ?? 0;
  },
  markRead: async (id) => {
    const res = await notificationApi.markRead(id);
    return unwrap(res).data.notification;
  },
  markAllRead: async () => {
    await notificationApi.markAllRead();
    return true;
  },
  remove: async (id) => {
    await notificationApi.remove(id);
    return true;
  },
};
